/**
 * @type {{set(string, string, number): void, get(string): string, has(string): boolean}}
 */
const Cookie = {
    /**
     * Get Cookie
     *
     * @description Get cookie value by name
     *
     * @example
     * Cookie.get(name);
     *
     * @param {string} name - cookie name
     * @returns {string}
     */
    get(name) {
        const cookieName = `${name}=`;
        const cookies = document.cookie.split(';');

        for (let i = 0, length = cookies.length; i < length; i++) {
            let cookie = cookies[i].trim();

            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }

        return '';
    },

    /**
     * Set Cookie
     *
     * @description Set a cookie with the name and value
     *
     * @example
     * Cookie.set(name, value, 1);
     *
     * @param {string} name - cookie name
     * @param {string} value - cookie value
     * @param {number} minutes - cookie expires (minutes)
     * @returns {void}
     */
    set(name, value, minutes) {
        const date = new Date();
        date.setTime(date.getTime() + (minutes * 60 * 1000));
        const expires = `expires=${date.toUTCString()}`;

        document.cookie = `${name}=${value}; ${expires}; path=/`;
    },

    /**
     * Has Cookie
     *
     * @description Checks if a cookie exists with that name
     *
     * @example
     * Cookie.has(name);
     *
     * @param {string} name - cookie name
     * @returns {boolean}
     */
    has(name) {
        return this.get(name) !== '';
    }
};

export default Cookie;
